import styled from 'styled-components';
import { StructuredText } from 'react-datocms';
import type { ProductCardFragment } from '@/utils/dato/generated';
import { ImageCardContent, ImageCard } from '@/components/ImageCard';
import { isEmptyDocument, type Document } from 'datocms-structured-text-utils';
import { listItemIconRule, paragraphRule, headingRule, renderBlock, listRule } from '@/components/structuredText';

const Content = styled(ImageCardContent)`
  &:has(.button:last-child) {
    min-height: 500px;
    padding-bottom: 82px;
  }

  .button {
    width: 100%;

    &:last-child {
      position: absolute;
      width: auto;
      bottom: 20px;
      right: 32px;
      left: 32px;
    }
  }
`;

const ProductCard = ({ productCardContent, image }: ProductCardFragment) => (
  <ImageCard data-automation="ZA.product-card" image={image?.responsiveImage}>
    {!isEmptyDocument(productCardContent?.value) ? (
      <Content>
        <StructuredText
          data={{ value: productCardContent?.value as Document, blocks: productCardContent?.blocks }}
          customNodeRules={[paragraphRule, headingRule, listRule, listItemIconRule('check')]}
          renderBlock={renderBlock}
        />
      </Content>
    ) : null}
  </ImageCard>
);

export default ProductCard;
